import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import MergeIdForm, { IMergeIdFormProps } from "../forms/mergeIdForm";
import DeviceContext from "../../service/indentifyDevice";
import "../../../assets/scss/components/login/loginScreen/loginScreen.scss";
import { getPreLoginData } from "../../service/login/loginService";
import logo from "../../../assets/images/logo_white.jpg";

export interface IMergeIdScreenProps extends IMergeIdFormProps {
	onClose?: () => void;
}

const MergeIdScreen: React.FC<IMergeIdScreenProps> = ({ onClose, ...props }) => {
	return (
		<LoginPopup
			leftHeaderContent={DeviceContext().isMobile ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : undefined}
			centerHeaderContent={DeviceContext().isMobile ? undefined : <img src={logo} alt="nuvama" className="nuvama_logo"/>}
			onClose={onClose}
			className="change_pw_scrn"
		>
			<section className="login_form merge_id_form">
				<div className={"header " + (DeviceContext().isMobile ? "mg-b30" : "mg-b40")}>
					<span className="circles ib mg-b30"></span>

					<h1 className={"title " + (DeviceContext().isMobile ? "mg-b10" : "mg-b20")}>
						Hi {getPreLoginData("userID")}! You have both equity and commodity accounts. You can choose to use a single id to login to both
						accounts
					</h1>

					<h2 className="subtitle">Once confirmed, the details below cannot be changed</h2>
				</div>

				<MergeIdForm {...props} />
			</section>
		</LoginPopup>
	);
};

export default MergeIdScreen;
